module.exports = __webpack_public_path__ + "static/twitter-2cdedbd836c543c15392aab2de839637.png";